import { createContext } from 'react';

/**
 * True inside `DemoScope`, the read-only "Take the guided tour" wizard. This
 * is what `useDemoTourActive` reads: the wizard api registry
 * (`WizardApiProvider`) is no longer a demo marker, since the live wizard
 * provides it too whenever the Spark assistant panel is open.
 */
export const DemoTourScopeContext = createContext(false);
